// Module
var code = "<button class=\"btn btn-primary responsive\" ng-disabled=\"ctrl.items.length < 1\" ng-click=\"ctrl.buttonClicked()\"> Generate Reports <i class=\"fa fa-file-pdf-o\"></i> </button>";
// Exports
var _module_exports = code;;
var path = 'reporting/ui/reportBatchDownloader/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;